import { configureStore, combineReducers } from 'redux-starter-kit';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { reducer as reduxFormReducer } from 'redux-form';
import thunk from 'redux-thunk';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import users from 'store/modules/users/users';
import auth from 'store/modules/auth/auth';
import assistant from 'store/modules/assistant/assistant';
import projects from 'store/modules/projects';
import project from 'store/modules/project/project';
import organizations from 'store/modules/organizations/organizations';
import intl from 'store/modules/intl/intl';
import products from 'store/modules/products';
import briefings from 'store/modules/briefings';
import workbenches from 'store/modules/workbenches';
import reports from 'store/modules/reports';
import ui from 'store/modules/ui';
import { history } from 'consts/routing';
import { CLEAR_STORE } from 'store/modules/auth/auth';
import assets from 'store/modules/assets';

const appReducer = combineReducers({
  auth,
  users,
  assistant,
  organizations,
  intl,
  project,
  projects: projects.reducer,
  products: products.reducer,
  briefings: briefings.reducer,
  workbenches: workbenches.reducer,
  reports: reports.reducer,
  router: connectRouter(history),
  form: reduxFormReducer,
  ui: ui.reducer,
  assets: assets.reducer,
});

const rootReducer = (state: any, action: any) => {
  if (action.type === CLEAR_STORE) {
    state = undefined;
  }

  return appReducer(state, action);
};

const persistConfig = {
  key: '__state',
  whitelist: ['auth', 'assistant', 'intl'],
  storage,
};

const store = configureStore({
  reducer: persistReducer(persistConfig, rootReducer),
  middleware: [thunk, routerMiddleware(history)],
});

export const persistor = persistStore(store);

export type ReduxState = ReturnType<typeof appReducer>;

export default store;
